import { Client } from "./_clientService";

export async function getNotifications(params: any) {
  let payload = {
    pageNo: params.pageNo ?? 1,
    limit: params.pageSize ?? 10,
    sortKey: params.sortKey ?? "createdAt",
    sortDir: "DESC",
    search: params.searchValue ?? "",
    skipPagination: params.skipPagination ?? false,
    archived: params.archived ?? false,
  };

  const resp = await new Client({ path: "/notification/list", payload }).post();

  return resp;
}
export async function createNotification(payload: any) {
  const resp = await new Client({
    path: "/notification/create",
    payload,
  }).post();
  return resp;
}

export async function updateNotification(payload: any) {
  const resp = await new Client({
    path: "/notification/update",
    payload,
  }).post();
  return resp;
}

export async function getNotificationInfo(notificationId: any) {
  const resp = await new Client({
    path: "/notification/info",
    payload: { notificationId },
  }).post();
  return resp;
}

export async function updateNotificationStatus(notificationId: any) {
  const resp = await new Client({
    path: "/notification/update/status",
    payload: { notificationId },
  }).patch();
  return resp;
}

export async function deleteNotification(notificationId: any) {
  const resp = await new Client({
    path: "/notification/delete",
    payload: { notificationId },
  }).post();
  return resp;
}

export async function copyNotification(notificationId: any) {
  const resp = await new Client({
    path: `/notification/copy`,
    payload: { input: { notificationId } },
  }).post();

  return resp;
}
export async function archiveNotifications(ids: string[]) {
  const resp = await new Client({
    path: "/notification/archive",
    payload: { ids },
  }).post();
  return resp;
}

export async function unarchiveNotifications(ids: string[]) {
  const resp = await new Client({
    path: "/notification/unarchive",
    payload: { ids },
  }).post();
  return resp;
}
